<template>
    <LoadingSpinner v-if="loading" />
    <DxToast v-model:visible="isToastVisible"
             v-model:message="toastMessage"
             :displayTime="4000"
             maxWidth="80%">
    </DxToast>
    <div id="popup"></div>
    <div class="page-content">
        <div class="content">
            <h1 class="pqHeadFirst">
                Micro Focus Groups
            </h1>
            <h2 class="pqHeadSec">
                AI Grid is a network of small, highly specialized AI communities. Within these communities, AI Grid members share on their research work, initiate collaborations and build fruitful connections for the future.

            </h2>
            <span class="pqHeadThird">
                Over 50 communities will be created over time.
                Check out the micro focus groups already established here and get in touch with their members. If you are interested in joining one of these communities, you can send a request by clicking on the community's description.
            </span>

        </div>
        <div class="bg-image-sq">
            <img class="mfg-img-bg bg-image" v-bind:src="bgSq" />
        </div>
    </div>

    <div class="mfgButtonsTop">
        <div class="mfgButton mfgBackButton">
            <DxButton text="Back"
                      styling-mode="text"
                      type="default"
                      icon="fa-regular fa-circle-arrow-left"
                      @click="backToOverview($event)" />
        </div>
    </div>

    <div class="home" id="cisRsi">

        <div class="tsKampagnenBox">
            <div v-for="data in mfgList" :key="data.TopicId" class="tsFor">
                <div class="tsKampagne">
                    <div class="tsSuchfeldBox" @click="OpenMorePopUp(data)">
                        <div class="tsFor tsForIn">
                            <div class="tsSuchfeld">
                                <div class="tsSuchfeldTitle">
                                    {{  data.Title }}
                                </div>
                                <div v-if="data.ImgUrl" class="tsSuchfeldImage">
                                    <img :src="data.ImgUrl" />
                                </div>
                                <div v-else class="tsSuchfeldImage">
                                    <img :src="mfgSq" />
                                </div>
                            </div>
                            <div class="hashtags">
                                <span v-if="data.Hashtags">
                                    <span v-for="hashtag in data.Hashtags" :key="hashtag" class="hashtag">
                                        #{{ hashtag }}&ensp;
                                    </span>

                                </span>
                            </div>
                            <!--<div class="tsButton">
                                <DxButton class="tsBtnDx" :text="btn.ChooseBtn" />
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <DxPopup v-model:visible="popup.visible"
             :title="popup.title"
             height="auto"
             target="#popup"
             :max-width="1200"
             :max-height="600"
             content-template="interested">

        <template #interested>
            <DxScrollView direction="vertical"
                          show-scrollbar="always"
                          scroll-by-content="true"
                          scroll-by-thumb="true">
                <div class="puMessage">
                    <div class="mfgInfo">
                        <div class="description">
                            <div class="mfgPopUpTlt">
                                About this Micro Focus Group
                            </div>
                            <div class="mfgPopUpText">
                                {{popup.description}}
                            </div>
                        </div>
                        <div class="mfg-img">
                            <img :src="popup.imgUrl" v-if="popup.imgUrl" class="mfg-img" />
                            <img v-else :src="mfgSq" />
                        </div>
                    </div>

                    <!--<div>
                <span class="mfgPopUpTlt">
                    MFG created on:
                </span>

            </div>-->
                    <div class="mfg-mentors mfg-membership" v-if="popup.ambassadors && popup.ambassadors.length>0">
                        <div class="tltStatus">
                            <span class="tltStatusButton tltStatusButtonAmbassador">
                                Ambassadors
                            </span>
                        </div>
                        <span class="prof">
                            <span class="mfg-img" v-for="topic in  popup.ambassadors" :key="topic.TopicId">
                                <img id="link2" @mouseenter="ToggleDefaultMentor(topic)"
                                     @mouseleave="ToggleDefaultMentor(topic)" class="mfg-img-prof" v-if="topic.ProfilePhoto" :src="topic.ProfilePhoto">
                                <i class="mfg-img-prof fal fa-user" id="link2" @mouseenter="ToggleDefaultMentor(topic)"
                                   @mouseleave="ToggleDefaultMentor(topic)" v-else />
                            </span>
                        </span>
                    </div>
                    <div class="all_profiles">

                        <div class="membersMentors">
                            <div class="mfg-membership" v-if="popup.members && popup.members.length>0">
                                <div class="tltStatus">
                                    <span class="tltStatusButton">
                                        Members
                                    </span>
                                </div>
                                <span class="mfg-prof">
                                    <span v-for="topic in  this.popup.members" :key="topic.TopicId">
                                        <img id="link1" @mouseenter="ToggleDefaultMember(topic)"
                                             @mouseleave="ToggleDefaultMember(topic)"
                                             @click="OpenProfile(topic)"
                                             class="mfg-img-prof" v-if="topic.ProfilePhoto"
                                             :src="topic.ProfilePhoto">
                                        <i class="mfg-img-prof fal fa-user" id="link1" @mouseenter="ToggleDefaultMember(topic)"
                                           @click="OpenProfile(topic)"
                                           @mouseleave="ToggleDefaultMember(topic)" v-if="!topic.ProfilePhoto" />
                                    </span>
                                </span>
                            </div>
                            <div class="mfg-mentors mfg-membership" v-if="popup.mentors && popup.mentors.length>0">
                                <div class="tltStatus">
                                    <span class="tltStatusButton tltStatusMentorButton">
                                        Mentors
                                    </span>
                                </div>

                                <span class="mfg-prof">
                                    <span v-for="topic in  this.popup.mentors" :key="topic.TopicId">
                                        <img id="link2" @mouseenter="ToggleDefaultMentor(topic)"
                                             @mouseleave="ToggleDefaultMentor(topic)"
                                             class="mfg-img-prof" v-if="topic.ProfilePhoto"
                                             @click="OpenProfile(topic)"
                                             :src="topic.ProfilePhoto">
                                        <i class="mfg-img-prof fal fa-user" id="link2" @mouseenter="ToggleDefaultMentor(topic)"
                                           @click="OpenProfile(topic)"
                                           @mouseleave="ToggleDefaultMentor(topic)" v-if="!topic.ProfilePhoto" />
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <DxPopover :width="auto"
                               heigth="100"
                               max-width="500"
                               :visible="memberPopoverVisible"
                               :shading="false"
                               :hideOnOutsideClick="true"
                               target="#link1"
                               position="top"
                               content-template="popoverContent1">
                        <template #popoverContent1>
                            <div class="popoverContent1">
                                <div class="pop_over_first mfg-membership">
                                    <div class="tltStatus tltDevider">
                                        <div class="data-caption">
                                            <div class="tltStatusButton">
                                                Member
                                            </div>
                                            <p>
                                                {{ topicDetail.UsrFirstName}}
                                                <br />
                                                {{ topicDetail.UsrLastName}}
                                            </p>
                                        </div>

                                        <img class="mfg-img-prof" v-if="topicDetail.ProfilePhoto" :src="topicDetail.ProfilePhoto">
                                        <i class="mfg-img-prof far fa-user" v-else />


                                    </div>


                                </div>
                                <div class="popOver-field">
                                    <span>Current status </span>  <br /> <span class="data-caption">{{ topicDetail.TdgText004}}</span>
                                </div>
                                <div class="popOver-field">
                                    <span>Fields of research in AI </span>  <br />
                                    <span class="data-caption" v-for="(tag,index) in topicDetail.AiTagsGrouped" :key="tag.LitParentId">
                                        <span v-if="index>0">, {{tag.LitShortName }}</span>
                                        <span v-else>{{tag.LitShortName }}</span>
                                    </span>
                                </div>
                            </div>
                        </template>

                    </DxPopover>
                    <DxPopover :width="auto"
                               heigth="100"
                               max-width="500"
                               :min-width="100"
                               :visible="ambassadorPopoverVisible"
                               :shading="false"
                               :hideOnOutsideClick="true"
                               target="#link3"
                               position="top"
                               content-template="popoverContent1">
                        <template #popoverContent1>
                            <div class="popoverContent1">
                                <div class="pop_over_first mfg-membership">
                                    <div class="tltStatus">
                                        <div class="data-caption">
                                            <div class="tltStatusButtonAmbassador">
                                                Ambassador
                                            </div>
                                            <p>
                                                {{ topicDetail.AmbassadorName}}
                                            </p>
                                        </div>

                                        <img class="mfg-img-prof" v-if="topicDetail.ProfilePhoto" :src="topicDetail.ProfilePhoto">
                                        <i class="mfg-img-prof far fa-user" v-else />


                                    </div>


                                </div>
                                <!--<div class="popOver-field">
                            <span>Current status </span>  <br /> <span class="data-caption">{{ topicDetail.TdgText004}}</span>
                        </div>
                        <div class="popOver-field">
                            <span>Fields of research in AI </span>  <br />
                            <span class="data-caption" v-for="(tag,index) in topicDetail.AiTagsGrouped" :key="tag.LitParentId">
                                <span v-if="index>0">, {{tag.LitShortName }}</span>
                                <span v-else>{{tag.LitShortName }}</span>
                            </span>
                        </div>-->
                            </div>
                        </template>

                    </DxPopover>
                    <DxPopover :width="auto"
                               heigth="100"
                               max-width="500"
                               :visible="mentorPopoverVisible"
                               :shading="false"
                               :hideOnOutsideClick="true"
                               target="#link2"
                               position="top"
                               content-template="popoverContent2">
                        <template #popoverContent2>
                            <div class="popoverContent1">
                                <div class="pop_over_first mfg-membership">
                                    <div class="tltStatus">
                                        <div class="data-caption">
                                            <div class="tltStatusButton tltStatusMentorButton">
                                                Mentor
                                            </div>
                                            <p>
                                                {{ topicDetail.UsrFirstName}}
                                                <br />
                                                {{ topicDetail.UsrLastName}}
                                            </p>
                                        </div>
                                        <img class="mfg-img-prof" v-if="topicDetail.ProfilePhoto" :src="topicDetail.ProfilePhoto">
                                        <i class="mfg-img-prof far fa-user" v-else />
                                    </div>
                                </div>
                                <div class="popOver-field">
                                    <span>Fields of research in AI </span>  <br />
                                    <span class="data-caption" v-for="(tag,index) in topicDetail.AiTagsGrouped" :key="tag.LitParentId">
                                        <span v-if="index>0">, {{tag.LitShortName }}</span>
                                        <span v-else>{{tag.LitShortName }}</span>
                                    </span>
                                </div>
                            </div>
                        </template>

                    </DxPopover>


                    <div v-if="popup.events && popup.events.length > 0">
                        <span class="mfgPopUpTlt">
                            Events:
                        </span>
                    </div>

                </div>

            </DxScrollView>
            <div class="mfgChangeStateButtons">
                <div class="mfgChangeStateButton">
                    <DxButton text="Close"
                              @click="popupCancel"
                              icon="fal fa-circle-xmark"
                              type="default"></DxButton>
                </div>
                <div class="mfgChangeStateButton" v-if="canApplyAsMentorForMfg || (canApplyAsMemberForMfg && canApply.hasMfg )">
                    <DxButton text="Apply"
                              @click="applyForMfg"
                              icon="fal fa-plus"
                              v-if="canApplyAsMemberForMfg"
                              type="success">
                    </DxButton>
                    <DxButton text="Mentor this group"
                              @click="mentorForMfg"
                              icon="fal fa-plus"
                              v-else-if="canApplyAsMentorForMfg"
                              type="success">
                    </DxButton>

                </div>

                <span class="statusValue" v-else-if="popup.currentMember.StgId!=0 && popup.currentMember.statusName">
                    {{popup.currentMember.statusName}}
                </span>
                <div class="mfgChangeStateButton" v-else-if="canApplyAsMemberForMfg && !canApply.hasMfg ">
                    <DxButton text="Change Micro Focus Group"
                              @click="changeMf"
                              icon="fal fa-plus"
                              v-if="canApplyAsMemberForMfg"
                              type="success">
                    </DxButton>
                </div>
            </div>
        </template>

    </DxPopup>
</template>

<script>
    import $ from 'jquery';
    import { DxButton } from 'devextreme-vue/button';
    import { DxPopover } from 'devextreme-vue/popover';
    import LoadingSpinner from "@/views/widgets/LoadingSpinner"
    import { DxPopup } from 'devextreme-vue/popup';
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import { DxToast } from 'devextreme-vue/toast';
    import {confirm } from "devextreme/ui/dialog"
    export default {
        name: 'MfgsOverview',
        components: {
            DxButton,
            DxPopup,
            DxScrollView,
            DxPopover,
            LoadingSpinner,
            DxToast
        },
        data() {
            return {
                bgSq: "",
                usrDefaultImage: "~/Images/default_profile.png",
                mfgSq: "~/Images/MFG.svg",
                ambassadorPopoverVisible: false,
                memberPopoverVisible: false,
                memberPopoverFixed: false,
                mentorPopoverVisible: false,
                mentorPopoverFixed: false,
                btn: {
                    ChooseBtn: this.$LanguageProvider.GetResource("ChooseBtn", "Caption", "More..."),
                },
                topicDetail: {},
                post: null,
                loading: false,
                popup: {
                    visible: false,
                    currentMember: {
                        status: 0,
                        stgID: 0,
                        statusTex: "",
                        StatusName: "",

                    },
                    topicLinkList: [],
                    title: " ",
                    loading: true,
                    topicId: 0,
                    data: {},
                    createdOn: "",
                    mentors: [],
                    ambassadors: [],
                    members: [],
                    events: [],
                    description: " ",
                    hasAmbassedor: false,
                    imgUrl: " ",
                    isToastVisible: false,
                    toastMessage: ""
                },
                ambassador: {
                    AmbassadorName: "",
                    TopicID: 0,
                    ProfilePhoto: ""
                },
                canApply: { hasMfg: false, nAppliedForThisMfg: false },
                mfgListCrtMember: null,
                myProfiles: null
            }
        },
        computed: {
            canApplyAsMemberForMfg() {
                return !this.isMentor && this.canApply.nAppliedForThisMfg && this.hasPublishedParticipantProfile;
            },
            canApplyAsMentorForMfg() {
                return this.isMentor && this.canApply.nAppliedForThisMfg && this.hasPublishedMentorProfile;
            },
            args() {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                return params.get("args");
            },
            mfgList() {
                var result = this.$store.state.topicLinkStore.mfgList.filter(m => m.StgId >= 10 && m.StgId < 20);
                result.forEach(m => {
                    if (m.Hashtags)
                        m.Hashtags = m.Hashtags.split(",");
                })
                return result
            },
            linkedTopicsByLinkTypeList() {
                var result = this.$store.state.topicLinkStore.linkedTopicsByLinkTypeList
                return result
            },

            isMentor() {
                return this.$store.state.accessStore.accessList._300751
            },
            profilesInfo() {
                return this.$store.state.accessStore.profilesInfo;
            },
            hasPublishedMentorProfile() {
                return this.$store.state.accessStore.hasPublishedMentorProfile;
            },
            hasPublishedParticipantProfile() {
                return this.$store.state.accessStore.hasPublishedParticipantProfile;
            },
            topicList() {
                var result = this.$store.state.topicStore.topicList;
                if (result.length > 0)
                    return result
                return []
            },
            modulTypeAttributeList() {
                var result = this.$store.state.applicationStore.modulTypeAttributeList
                if (result && result.length > 0 && result[0].groupData == undefined) {
                    result.forEach(m => {
                        m.ShowSelectionPopup = false;
                        m.groupData = this.processGrouped(m)
                    })
                }
                return result
            },
        },
        mounted() {
            this.$store.dispatch("getAccessList", { tokenList: ["300751"] });
            this.$store.dispatch("getMfgList", {})
            this.$store.dispatch("getProfilesInfo", {})
            this.$store.dispatch("getMyAiGridProfiles", { ttyId: null }).then((res) => {
                this.myProfiles = res.data.profiles;
                this.myProfiles = this.myProfiles.filter(m =>
                    m.TtyId == 22 || m.TtyId == 24
                )
                this.mfgListCrtMember = this.myProfiles[0].MfgList.filter(m => m.StgId == 15);
            })
        },
        created: function () {


        },
        props: {
            mode: {
                type: String,
                required: false,
            }
        },
        watch: {

        },
        methods: {
            OpenProfile(topic) {
                this.loading = true;
                $("form").attr("action", window.location.pathname + "?action=view&id=" + topic.TopicID).submit()
            },
            ToggleDefaultMember(topic) {
                this.topicDetail = topic;
                this.memberPopoverVisible = !this.memberPopoverVisible;
            },
            ToggleDefaultAmbassador(topic) {
                this.topicDetail = topic;
                this.ambassadorPopoverVisible = !this.ambassadorPopoverVisible;
            },
            ToggleDefaultMentor(topic) {
                this.topicDetail = topic;
                this.mentorPopoverVisible = !this.mentorPopoverVisible;
            },
            popupCancel() {
                this.popup.visible = false;
            },
            changeMf() {
                confirm("Are you sure you want to change your Micro Focus Group?", "Confirm Deletion").then(
                    res => {
                        if (res) {
                            this.loading = true;
                            this.applyForMfg();
                        }
                    }
                );
            },
            applyForMfg() {

                this.$store.dispatch("addTopicToMfg", { topicId: this.popup.topicId, args: this.args }).then((res) => {
                    if (res.data.success) {
                        this.popup.visible = false;
                        this.isToastVisible = true
                        this.toastMessage = "You have successfully applied for a Micro Focus Group."
                    }
                    this.loading = false;
                })
            },
            mentorForMfg() {
                this.$store.dispatch("addTopicToMfg", { topicId: this.popup.topicId, args: this.args }).then((res) => {
                    if (res.data.success) {
                        this.popup.visible = false;
                        this.isToastVisible = true
                        this.toastMessage = "Your request to mentor this group has been successfully forwarded to the AI Grid team."
                    }
                })
            },
            backToOverview() {
                window.location.href = window.location.pathname + "?action=back&args=" + this.args;
            },
            OpenMorePopUp(data) {
                this.loading = true;

                this.$store.dispatch("getApplicantData", data.TopicId).then((m) => {
                    this.popup.topicId = data.TopicId;
                    this.popup.members = m.data.Members.filter(m => m.TtyId == 22 && m.StgId == 15);
                    this.popup.isLinkedAsMember = m.data.Members.filter(m => m.IsLinkMember == true).length > 0 ? true :false;
                    this.popup.isLinkedAsMentor = m.data.Mentors.filter(m => m.IsLinkMember == true).length > 0 ? true : false;
                    if (this.popup.isLinkedAsMember) {
                        this.popup.currentMember.status = m.data.Members.filter(e => e.IsLinkMember == true)[0].StatusId;
                        this.popup.currentMember.stgID = m.data.Members.filter(e => e.IsLinkMember == true)[0].StgId;
                        this.popup.currentMember.statusName = m.data.Members.filter(e => e.IsLinkMember == true)[0].StatusName;
                    }
                    else if (this.popup.isLinkedAsMentor) {
                        this.popup.currentMember.status = m.data.Mentors.filter(e => e.IsLinkMember == true)[0].StatusId;
                        this.popup.currentMember.stgID = m.data.Mentors.filter(e => e.IsLinkMember == true)[0].StgId;
                        this.popup.currentMember.statusName = m.data.Mentors.filter(e => e.IsLinkMember == true)[0].StatusName;
                    }
                    else {
                        this.popup.currentMember.status = 0;
                        this.popup.currentMember.stgID = 0;
                        this.popup.currentMember.statusName = "";
                    }
                    this.popup.mentors = m.data.Mentors.filter(m => !m.IsAmbassador && m.StgId == 15);
                    this.popup.ambassadors = m.data.Mentors.filter(m => m.IsAmbassador && m.StgId == 15);
                    this.popup.events = m.data.Events;
                    this.popup.visible = true;
                    this.popup.data = data;
                    this.popup.title = data.Title;
                    this.popup.description = data.Description;
                    this.popup.hasAmbassedor = data.TpcHasAmbassedor;
                    this.ambassador.AmbassadorName = data.AmbassadorName;
                    this.ambassador.TopicID = data.AmbassadorId;
                    this.ambassador.ProfilePhoto = data.AmbassedorProfilePhoto;
                    this.popup.imgUrl = data.ImgUrl;
                    this.loading = false;

                    this.canApply.hasMfg = this.mfgListCrtMember && this.mfgListCrtMember.length == 0;
                    this.canApply.nAppliedForThisMfg = !this.popup.isLinkedAsMentor && !this.popup.isLinkedAsMember && this.popup.currentMember.stgID == 0;

                })

            },
        }

    }

</script>
<style scoped>
    .membersMentors {
        display: grid;
        grid-column-gap: 30px;
        grid-template-columns: 2fr 1fr;
    }

    .tltDevider {
        border-bottom: solid 1px silver;
    }

    span.statusValue {
        background-color: #efefef;
        padding: 11px 23px;
    }

    .puLabel .puValue input {
        width: 239px;
        margin-top: 3px;
    }

    .tsFor {
        z-index: 1;
    }

    .page-content {
        display: flex;
    }

    .mfg-img {
        text-align: right;
    }

    div.content {
        max-width: 1000px;
    }

    h1.pqHeadFirst {
        text-align: unset;
    }

    .all_profiles {
        display: grid;
        grid-auto-flow: column;
        padding-top: 15px;
        margin-bottom: 30px;
        grid-template-rows: 1fr;
    }




    .home {
        width: 100%;
        display: flex;
        /*grid-template-columns: 3fr 1fr;*/
        margin: 10px 0px 10px 0px;
    }



    div#cisRsi {
        width: 100%;
        display: grid;
    }

    .tsKampagne {
        height: 100%;
    }

    .tsKampagnenBox {
        width: 100%;
        z-index: 10;
        min-height: 200px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        /* justify-content: center; */
        gap: 20px 20px;
    }

    span.mfgPopUpTlt {
        font-weight: bold;
        padding-bottom: 5px;
    }


    .popoverContent1 {
        display: grid;
        row-gap: 5px;
    }

    .roundBackground {
        color: white;
        padding: 2px 10px;
        block-size: 22px;
        width: fit-content;
        border-radius: 10px;
    }

    .gray {
        background-color: #464b54;
    }

    .orng {
        background-color: #e97035;
    }

    .tsForIn {
        border: solid 1px #ebebeb;
        display: flex;
        justify-content: space-between;
        box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 10%);
        flex-direction: column;
    }

    .puMessage {
        display: grid;
        font-size: 15px;
    }



    .mfg-mentors {
        justify-content: right;
    }

    .tsSuchfeldDescription {
        padding-top: 10px;
        font-size: var(--grid-suchfeld-description-size);
        color: var(--grid-suchfeld-description-color);
    }


    .tsSuchfeldTitle {
        font-size: 19px;
        font-weight: bold;
        color: #465a64;
        min-height: 20px;
        /*  padding: 6px 6px 0 15px;*/
        margin-bottom: 10px;
    }

    .tsKampagneTitle {
        font-size: 20px;
        font-weight: bold;
        padding-left: 15px;
    }

    .tsSuchfeldImage {
        align-self: self-end;
        height: inherit;
    }

    .tsHeader {
        display: flex;
        width: 100%;
        grid-column-gap: 10px;
        float: left;
        clear: both;
        max-width: initial;
    }

        .tsHeader img {
            max-width: 100%;
            padding: 10px;
        }

    .tsSuchfeldImage img {
        width: 100%;
        object-fit: cover;
        height: 225px;
    }

    .tsSuchfeld {
        padding: 15px 15px 5px 15px;
        display: grid;
        grid-auto-flow: row;
        grid-template-rows: auto 1fr;
        height: 100%;
    }


    .tsSuchfeldBox {
        height: 100%;
    }

    .tsFor.tsForIn {
        cursor: pointer;
        background-color: white;
    }

        .tsFor.tsForIn:hover {
            background-color: whitesmoke;
        }

    .tsButton {
        margin-top: 15px;
        display: flex;
        justify-content: center;
        padding-bottom: 14px;
    }

    .tsForIn:hover {
        box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 15%);
    }

    .tsBtnDx {
        width: 95%;
    }

    .tsFor {
        flex-grow: 1;
        width: 100%;
        height: inherit;
        max-width: 350px;
    }

    img.mfg-img {
        max-height: 370px;
        object-fit: cover;
    }

    .tsKampagneImage {
        width: 100px;
    }

    .mfgChangeStateButtons {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        margin-top: 10px;
        padding: 15px 0px;
        bottom: 0;
        background-color: white;
        position: sticky;
    }


    @media only screen and (max-width: 1200px) {
        .home {
            grid-template-columns: auto;
        }

        .tsKampagnenBox {
            display: grid;
            width: fit-content;
            grid-template-columns: 1fr 1fr;
            grid-row-gap: 15px;
        }
    }

    .mfgPopUpTlt {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 5px;
    }

    .mfgButtonsTop {
        margin-top: 20px;
    }

    @media only screen and (max-width: 1000px) {
    }

    @media only screen and (max-width: 700px) {

        .tsKampagnenBox {
            grid-template-columns: 1fr;
            grid-row-gap: 20px;
        }

        .home {
            justify-items: center;
        }

        .mfgChangeStateButtons {
            flex-direction: column-reverse;
            row-gap: 20px;
            align-items: center;
        }
    }
</style>
